// Import Types
import type {
    AchievementGeneralDetails,
    AchievementListItem,
    CasinoGameItem,
    ChallengeTypeItem,
    DataWithPaging,
    PaymentSystemItem,
    SportCompetitionItem,
} from 'types';
// Import Services
import { CRMRequestService, postCancelableRequest, getCancelableRequest } from './http.config';

const AchievementHttpService = {
    getAchievementList: () => {
        return postCancelableRequest<DataWithPaging<AchievementListItem>>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/List',
        });
    },

    createAchievement: () => {
        return postCancelableRequest<AchievementGeneralDetails>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/Create',
        });
    },
    updateAchievement: () => {
        return postCancelableRequest<AchievementGeneralDetails>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/Update',
        });
    },
    getAchievementGeneralDetails: () => {
        return getCancelableRequest<AchievementGeneralDetails>({
            requestService: CRMRequestService,
            endpointPath: ({ id }) => `/Achievement/GetGeneralDetails?id=${id}`,
        });
    },
    getChallengeTypes: () => {
        return getCancelableRequest<ChallengeTypeItem[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/GetChallengeTypes',
        });
    },
    deleteAchievements: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Achievement/Delete`,
        });
    },
    archiveAchievement: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ id }) => `/Achievement/Archive?id=${id}`,
        });
    },
    unarchiveAchievement: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ id }) => `/Achievement/Unarchive?id=${id}`,
        });
    },
    getCasinoGames: () => {
        return postCancelableRequest<CasinoGameItem[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/GetCasinoGames',
        });
    },
    getSportCompetitions: () => {
        return postCancelableRequest<SportCompetitionItem[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/SportCompetitions',
        });
    },
    getPaymentSystems: () => {
        return postCancelableRequest<PaymentSystemItem[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Achievement/PaymentSystems',
        });
    },
    getAchievementById: () => {
        return getCancelableRequest<AchievementGeneralDetails>({
            requestService: CRMRequestService,
            endpointPath: ({ id, isClone }) => `/Achievement/Get?id=${id}&isClone=${isClone}`,
        });
    },
};

export default AchievementHttpService;
